import { PDFViewer } from "@react-pdf/renderer";
import PopupDialog from "components/dialog/PopupDialog";
import PDFExport from "layouts/PDFExport";
import { useState } from "react";

const usePDFRenderer = () => {
  const [popup, setPopup] = useState(false);
  const toggleViewer = () => setPopup(!popup);

  const getViewer = (conf) => {
    const { title = "", content = <></>, modalSize = "lg", modalZIndex, viewerKey = title, ...rest } = conf;
    return (
      <PopupDialog
        size={modalSize}
        title={title}
        show={popup}
        closeHandle={toggleViewer}
        zIndex={modalZIndex}
      >
        <PDFViewer key={viewerKey} className="col-md-12" style={{ height: title ? "70vh" : "75vh", border: "0px" }}>
          <PDFExport key={viewerKey} {...rest} title={title}>
            {content}
          </PDFExport>
        </PDFViewer>
      </PopupDialog>
    );
  };

  return [getViewer, toggleViewer];
};

export default usePDFRenderer;
